export default {
  methods: {
    bottomVisible() {
      // 다양한 브라우저 호환성을 위한 스크롤 위치 계산
      const scrollY =
        window.pageYOffset ||
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0

      // 뷰포트 높이 계산
      const visible =
        document.documentElement.clientHeight ||
        window.innerHeight ||
        document.body.clientHeight ||
        0

      // 페이지 전체 높이 계산
      const pageHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight,
        document.documentElement.offsetHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight
      )

      // 하단 감지 (더 큰 여유 마진으로 삼성 브라우저 호환성 향상)
      const margin = 100 // 이전 58에서 여유를 더 두어 100으로 조정
      const bottomOfPage = visible + scrollY >= pageHeight - margin

      return bottomOfPage || pageHeight < visible
    },
    buttonFocus() {
      setTimeout(() => {
        const btn = this.$refs.btn
        if (btn) {
          btn.focus()
        }
      }, 100)
    }
  }
}
